import { constantRoutes } from '@/router';
import { getTenantMenu } from '@/api/user';

const state = {
  routes: [],
  menu: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes;
  },
  SET_MENU: (state, menu) => {
    state.menu = menu;
  }
};

const actions = {
  generateRoutes ({ commit }) {
    return new Promise(resolve => {
      let domainName = window.location.href.split('//')[1].split('/')[0];
      if (domainName.indexOf('localhost') > -1) {
        domainName = 'dev.lontologie.com';
      }
      getTenantMenu({address: domainName}).then(response => {
        let routes = [];
        if (response.length > 0) {
          for (let j = 0; j < constantRoutes.length; j++) {
            if (constantRoutes[j].code) {
              // 过滤出设置权限的菜单
              // 找出一级为true的菜单
              // 在一级菜单的基础上找出二级为true的菜单
              for (let i = 0; i < response.length; i++) {
                if (constantRoutes[j].code == response[i].code && response[i].isShow) {
                  if (constantRoutes[j].children) {
                    for (let k = 0; k < constantRoutes[j].children.length; k++) {
                      for (let l = 0; l < response.length; l++) {
                        if (constantRoutes[j].children[k].code) {
                          if (constantRoutes[j].children[k].code == response[l].code) {
                            constantRoutes[j].children[k].hidden = !response[l].isShow;
                          }
                        }
                      }
                    }
                  }
                  routes.push(constantRoutes[j]);
                }
              }
            } else {
              routes.push(constantRoutes[j]);
            }
          }
        }
        commit('SET_ROUTES', routes);
        commit('SET_MENU', response);
        resolve();
      }).catch(error => {
        console.log(error);
        reject(error);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js